const PrivacyForm = () => {
  return (
    <div>
      <strong style={{ color: "red" }}>TBD</strong> - Privacy form
    </div>
  );
};

export default PrivacyForm;
